<template>
  <div :id="id" class="cfButton" v-html="content" @click="handleClick"></div>
</template>

<script>
  export default {
      name: 'cf-button',
      props: {id:String, content:String, animation:Boolean, to:null, width:Number},
      activated(){
        TweenMax.to(`#${this.id}`, 0, {marginLeft:0, width:`${this.width}px`})
      },
      mounted(){
        TweenMax.to(`#${this.id}`, 0, {marginLeft:0, width:`${this.width}px`})
      },
      methods: {
        handleClick(){
          // console.log('i am clicked')
          if(this.animation || this.to){
            // console.log('i need to animate')
            TweenMax.to(`#${this.id}`, 0.25, {ease: Expo.easeIn, marginLeft:`${this.width}px`, width:0, onComplete:this.gotoRoute})
          }
        },
        gotoRoute(){
          this.$router.push(this.to);
        }
      },     
  };
</script>

<style scoped>
  .cfButton {
    position: absolute;
    cursor: pointer;
    line-height: 70px;
    height: 70px;       
    overflow: hidden;

    border:1px solid white;
    text-align: center;
    vertical-align: middle;
    stroke: white;
    stroke-width: 1px;
    font-size: 38px;    
  }
</style>





// WEBPACK FOOTER //
// CF-Button.vue?465844d8